import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent {
  @Input() backdropClass: string;
  @Input('class') panelClass: string;
}
